import { Component, input } from "@angular/core";
import { FuelRowComponent } from "../fuel-row/fuel-row.component";
import { MaxTank, REFUEL_FIELDS } from "../fuel-row/fuel-row";
import { RefuelArray } from "./refuel-group";

/** The refuels before the first flight: a line of fuel each. */
@Component({
    selector: "app-refuel-tab",
    imports: [FuelRowComponent],
    templateUrl: "./refuel-tab.component.html",
})
export class RefuelTabComponent {
    readonly rows = input.required<RefuelArray>();
    /** The units the organization logs fuel in. */
    readonly units = input.required<string[]>();
    /** The tanks' capacity, when the organization checks the fuel against it. */
    readonly maxTank = input<MaxTank>(null);

    readonly fields = REFUEL_FIELDS;
}
